import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'nrc-country-icon',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './country-icon.component.html',
  styleUrl: './country-icon.component.scss'
})
export class CountryIconComponent {
  @Input({ required: true }) public code!: string;
}

